import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import styles from './ProfileSideBar.module.css';
import EmployerProfilePlanUi from '../EmployerProfilePlanUi/EmployerProfilePlanUi';
import { useNavigate } from 'react-router-dom';

function ProfileSideBar({ activeTab, setActiveTab, title, description, description2, tabs, removeSubscriptionInformation, employerPortal, ...props }) {
    const { t } = useTranslation();
    const user = useSelector(state => state.user.user);
    const navigate = useNavigate()
    const handleTabClick = (index) => {
        if (employerPortal) {
            const navigateRoute = index == 1 ? `/employer-portal/candidates` : index == 2 ? '/employer-portal/applicants' : '/employer-portal/jobs'
            navigate(navigateRoute)
        } else {
            const tabs = [
                { path: '/profile/personal-information', },
                { path: '/profile/contact-information', },
                { path: '/profile/work-experience', },
                { path: '/profile/education', },
                { path: '/profile/skills', },
                { path: '/profile/occupation', },
                { path: '/profile/job-preferences', },
                { path: '/profile/resume', },
                { path: '/profile/certification', },
                { path: '/profile/portfolio', },
                { path: `/profile/account`, }
            ];
            if (user.account_type == 'employer') {
                if (user.employer_status == 'business') {
                    tabs.splice(2, 0, { path: `/profile/company-information`, }, { path: `/profile/account`, })
                } else {
                    tabs.splice(2, 0, { path: `/profile/account`, })

                }
                // tabs.splice(3, 0, { path: `/profile/account`, })

            }
            const route = tabs[index].path;
            navigate(route);
        }
    };
    let price = '$95';
    let price_reccuring = '$65';

    if (user?.subscription_price?.currency_options) {
        if (user.country === 'AE') {
            price = (Math.ceil(parseFloat(user?.subscription_price?.currency_options?.aed?.unit_amount_decimal) / 100) + 111) + 'د.إ(AED)';
            price_reccuring = (Math.ceil(parseFloat(user?.subscription_price?.currency_options?.aed?.unit_amount_decimal) / 100)) + 'د.إ(AED)';
        }
        else if (user.country === 'SA') {
            price = (Math.ceil(parseFloat(user?.subscription_price?.currency_options?.sar?.unit_amount_decimal) / 100) + 111) + 'ر.س(SAR)';
            price_reccuring = (Math.ceil(parseFloat(user?.subscription_price?.currency_options?.sar?.unit_amount_decimal) / 100)) + 'ر.س(SAR)';
        }
        else if (user.country === 'QA') {
            price = (Math.ceil(parseFloat(user?.subscription_price?.currency_options?.qar?.unit_amount_decimal) / 100) + 111) + 'درهم(QAR)';
            price_reccuring = (Math.ceil(parseFloat(user?.subscription_price?.currency_options?.qar?.unit_amount_decimal) / 100)) + 'درهم(QAR)';
        }

    }
    return (
        <div className={styles.sideBarContainer} {...props}>
            <div className={styles.tabsContainer}>
                <span className={styles.sideBarTitleContainer}>
                    <p className={styles.sideBarTitle}>{title ? title : t('profileSidebar.title')}</p>
                    <p className={styles.sideBarDesc}>{description ? description : t('profileSidebar.description')}</p>
                    {description2 && <p className={styles.sideBarDesc}>{description2}</p>}
                </span>
                <div className={styles.listContaienr}>
                    {tabs.map((tab, index) => {
                        return (
                            <div
                                key={index}
                                className={`${styles.tab} ${activeTab === index ? styles.activeTab : ''}`}
                                onClick={() => handleTabClick(index)}
                            >
                                <img
                                    src={tab.icon}
                                    alt={tab.name}
                                    className={`${styles.tabIcon} ${activeTab === index ? styles.activeTabIcon : ''}`}
                                />
                                <span className={`${styles.tabText} ${activeTab === index ? styles.activeTabText : ''}`}>
                                    {t(`profileSidebar.tabs.${tab.name}`)}
                                </span>
                            </div>
                        )
                    })}
                </div>
            </div>
            {!removeSubscriptionInformation && user.account_type !== 'jobseeker' && user.subscriptionStatus == 'active' && <EmployerProfilePlanUi />}

        </div>
    );
}

export default ProfileSideBar;




